import styled from 'styled-components';
import illustration from '../assets/images/backgrounds/illustration.svg';

export const MetaFooter = styled.div`
  background-image: url(${illustration});
  background-position: top center;
  background-size: cover;
`;
